module.exports = "<div research-request=\"request\" request-messages=\"messages\"></div>\n";